var $a6054f95cdb10fc3$exports = {};
$a6054f95cdb10fc3$exports = {
    "(optional)": `(\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A})`,
    "(required)": `(\u{645}\u{637}\u{644}\u{648}\u{628})`
};


export {$a6054f95cdb10fc3$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
